import React from 'react'
import DescriptionIcon from '@mui/icons-material/Description'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import ImageIcon from '@mui/icons-material/Image'
import GridOnIcon from '@mui/icons-material/GridOn'

/**
 * Returns the appropriate icon for a file extension
 * @param {string} fileExtension - The file extension
 * @returns {JSX.Element} The appropriate file icon
 */
export const getFileIcon = fileExtension => {
  switch (fileExtension.toLowerCase()) {
    case '.doc':
    case '.docx':
      return <DescriptionIcon sx={{ color: 'blue' }} />
    case '.pdf':
      return <PictureAsPdfIcon sx={{ color: 'red' }} />
    case '.png':
    case '.jpg':
    case '.jpeg':
      return <ImageIcon sx={{ color: 'skyblue' }} />
    case '.xls':
    case '.xlsx':
      return <GridOnIcon sx={{ color: 'green' }} />
    default:
      return <DescriptionIcon sx={{ color: 'grey.500' }} />
  }
}
